module.exports = __webpack_public_path__ + "img/analyze__msg.6ec2bd9c.svg";